import { useEffect, useState } from "react";
import { validateUsersContract } from "../../services/stacks";
import { useNavigate } from "react-router-dom";
import UserContractDeployModal from "../../components/modal/UserContractDeployModal";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { clientNetwork, stacksApi } from "../../lib/constants";
import { callReadOnlyFunction, cvToJSON, hexToCV, principalCV, uintCV } from "@stacks/transactions";
import axios from "axios";
import { authenticatedUserAddress } from "../../services/auth";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FaSearch } from "react-icons/fa";
import { Alert, Box, Button, Snackbar } from '@mui/material';
import { network } from '../../services/auth';
import ClaimMineRewardButton from "./claimMiningReward";
import './style.scss';
import ClaimMiningRewardListButton from "./claimMiningListReward";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import ClaimList from "./claimList";
import ClaimLongListButton from "./claimLongList";

const style_elBackground = {
    width: '100%',
    height: '100%',
};
const style_elBackground_outer = {
    boxSizing: 'border-box',
    backgroundColor: '#0c2321',
};

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

const MineRewads = ({ userSettings }) => {
    const [historyLoading, setHistoryLoading] = useState(false);
    const [minedBlocksLoading, setMinedBlocksLoading] = useState(false);
    const [userContractStatus, setUserContractStatus] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showUserContractDeployModal, setShowUserContractDeployModal] = useState(false);
    const [txId, setTxId] = useState();
    const [confirmTx, setConfirmTx] = useState();
    const [mineHistory, setMineHistory] = useState([]);
    const [displayMinedData, setDisplayMinedData] = useState([]);
    const [displayDataPagination, setDisplayDataPagination] = useState(0);
    const [minedBlockPageEnded, setMinedBlockPageEnded] = useState(false);
    const [selectedAccordion, setSelectedAccordion] = useState(null);
    const [mineOffset, setMineOffset] = useState(0);
    const [minePageEnded, setMinePageEnded] = useState(false);
    const [claimList, setClaimList] = useState([]);
    const [longClaimList, setLongClaimList] = useState([]);
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    const navigate = useNavigate();

    const navTo = (to_txId) => navigate(`/${to_txId}`);

    const requestMiningHistory = async () => {
        try {
            let total_mined_commits = 0, total_mined_blocks;
            const userAddress = authenticatedUserAddress({ network: clientNetwork });
            const currentBlock = (await axios.get(`${stacksApi}/extended/`)).data?.chain_tip?.block_height;
            const txHistory = (await axios.get(`${stacksApi}/extended/v1/contract/${userAddress}.derupt-profile/events?limit=5&offset=${mineOffset}`)).data?.results;

            if (txHistory?.length === 0) {
                setHistoryLoading(false);
                setMinePageEnded(true);
                return;
            }

            let filteredTxHistory = txHistory?.filter(res => res?.contract_log && res?.contract_log?.value);
            if (filteredTxHistory?.length === 0) {
                setHistoryLoading(false);
                return;
            }

            const minedTxHistoryEvents = await Promise.all(filteredTxHistory?.map(async ({ tx_id, contract_log: { value: { hex } } }) => {
                const { event } = cvToJSON(hexToCV(hex))?.value;
                await delay(2500);
                const mineEvents = (await axios.get(`${stacksApi}/extended/v1/tx/events?tx_id=${tx_id}`))?.data;

                if (!mineEvents?.events) return;

                const filteredMinedEvents = mineEvents?.events?.filter(res => res?.contract_log && res?.contract_log?.value);
                if (filteredMinedEvents?.length === 0) return;

                const events = filteredMinedEvents?.map(res => {
                    const { value: { hex } } = res?.contract_log;
                    return { hexValues: cvToJSON(hexToCV(hex))?.value, contract_id: res?.contract_log?.contract_id };
                });

                const filteredEvents = events?.filter(({ hexValues }) => hexValues?.event?.value === 'mine' && hexValues?.who);
                if (filteredEvents?.length === 0) return;
                const { hexValues: { userId, firstBlock, lastBlock, who, total: mineTotal }, contract_id } = filteredEvents[0];
                const blockDif = parseInt(lastBlock?.value) - parseInt(firstBlock?.value) + 1;
                total_mined_commits = mineTotal?.value / 1000000;
                total_mined_blocks = blockDif;
                const miningData = { userId: userId?.value, firstBlock: firstBlock?.value, lastBlock: lastBlock?.value, contract_id, who: who?.value };

                return {
                    event: event?.value, tx_id,
                    total_mined_commits,
                    total_mined_blocks,
                    current_block: currentBlock,
                    mine_data: miningData,
                    firstBlock: miningData.firstBlock,
                    lastBlock: miningData.lastBlock,
                };
            }));

            const sortedMinedTxHistoryEvents = minedTxHistoryEvents.filter(Boolean).sort((a, b) => b.current_block - a.current_block);

            setMineHistory(prev => [...prev, ...sortedMinedTxHistoryEvents]);
            setMineOffset(prev => prev + 5);
            setHistoryLoading(!minedTxHistoryEvents);
        } catch (error) {
            setOpenSnackBar(true);
            setErrorMsg(`${error.message}, slow down.`);
            setMinePageEnded(true);
            setHistoryLoading(false);
        }
    };

    const init = async () => {
        const { state, txId } = await validateUsersContract();
        if (state === false) {
            setUserContractStatus(state);
            setShowUserContractDeployModal(true);
        } else if (state === 'success' || state === 'mempool') {
            setTxId(txId);
            setUserContractStatus(state);
            setShowUserContractDeployModal(true);
        } else if (state === 'abort_by_post_condition' || state === 'abort_by_response') {
            setUserContractStatus("failed");
            setShowUserContractDeployModal(true);
        } else {
            setUserContractStatus(state);
            findMore();
        }
    };

    const fetchMinedBlockData = async (i) => {
        let constructMinedBlocksInfo = [];
        try {
            const currentBlock = (await axios.get(`${stacksApi}/extended/`))?.data?.chain_tip?.block_height;
            if (mineHistory[i]?.mine_data) {
                const { mine_data: { userId, firstBlock, lastBlock, contract_id, who } } = mineHistory[i];
                const blockDif = parseInt(lastBlock) - parseInt(firstBlock) + 1;
                if (displayDataPagination >= blockDif) setMinedBlockPageEnded(true);
                for (let x = displayDataPagination; x < blockDif && constructMinedBlocksInfo.length < 5; x++) {
                    const block = parseInt(firstBlock) + x;
                    try {
                        const blockWinner = cvToJSON((await callReadOnlyFunction({
                            contractAddress: contract_id?.split('.')[0],
                            contractName: contract_id?.split('.')[1],
                            functionName: 'is-block-winner',
                            functionArgs: [principalCV(who), uintCV(block)],
                            network: network({ network: clientNetwork }),
                            senderAddress: who
                        })))?.value;

                        let total_mined_rewards = 0;
                        if (blockWinner) {
                            total_mined_rewards = cvToJSON((await callReadOnlyFunction({
                                contractAddress: contract_id?.split('.')[0],
                                contractName: contract_id?.split('.')[1],
                                functionName: 'get-coinbase-amount',
                                functionArgs: [uintCV(block)],
                                network: network({ network: clientNetwork }),
                                senderAddress: who
                            })))?.value;
                            await delay(2500);
                        }

                        const canClaim = cvToJSON((await callReadOnlyFunction({
                            contractAddress: contract_id?.split('.')[0],
                            contractName: contract_id?.split('.')[1],
                            functionName: 'can-claim-mining-reward',
                            functionArgs: [principalCV(who), uintCV(block)],
                            network: network({ network: clientNetwork }),
                            senderAddress: who
                        })))?.value;

                        const blockInfo = {
                            userId,
                            block,
                            winner: blockWinner,
                            claimed: canClaim !== null ? !canClaim : canClaim,
                            pending: !((currentBlock - block) > 120),
                            contract_id,
                            total_mined_rewards
                        };
                        constructMinedBlocksInfo.push(blockInfo);
                        if (canClaim) setClaimList(prev => [...prev, block]);
                        setDisplayMinedData(prev => [...prev, blockInfo]);
                    } catch (error) {
                        setOpenSnackBar(true);
                        setErrorMsg(`${error.message}, slow down.`);
                        setMinedBlocksLoading(false);
                    }
                }
            }
            setMinedBlocksLoading(false);
        } catch (error) {
            setOpenSnackBar(true);
            setErrorMsg(`${error.message}, slow down.`);
            setMinedBlocksLoading(false);
        }
        setDisplayDataPagination(prev => prev + 5);
    };

    const handleAccordionOpen = (i) => {
        if (selectedAccordion !== i) {
            setMinedBlocksLoading(true);
            setSelectedAccordion(i);
            setDisplayMinedData([]);
            setDisplayDataPagination(0);
            setClaimList([]);
            setMinedBlockPageEnded(false); // Reset this state to ensure the "Load More" button is visible
        }
    };

    useEffect(() => {
        fetchMinedBlockData(selectedAccordion);
    }, [selectedAccordion]);

    const handleBlockDataPagination = async (i) => {
        setMinedBlocksLoading(true);
        await delay(2500);
        await fetchMinedBlockData(i);
    };

    const findMore = async () => {
        setHistoryLoading(true);
        await delay(2500);
        await requestMiningHistory();
    };

    useEffect(() => {
        init();
    }, []);

    return (
        <>
            <div className="rewards-container">
                <div className="background">
                    <div className="containerMinHeight elBackground" style={style_elBackground_outer}>
                        <div className="appBg" style={style_elBackground} />
                    </div>
                </div>

                <div className="rewards-items">
                    <Box id="rewards-box"
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignContent: 'center',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%'
                        }}>
                        <CustomTabPanel id="rewards-panel">
                            <ClaimLongListButton longList={longClaimList} setConfirmTx={setConfirmTx} setShowConfirmModal={setShowConfirmModal} />
                            {mineHistory && mineHistory.map(({ tx_id, total_mined_blocks, total_mined_commits, firstBlock, lastBlock }, index) => (
                                <Accordion disabled={minedBlocksLoading} expanded={selectedAccordion === index} sx={{ marginBottom: '1rem', backgroundColor: 'transparent', color: '#fff' }} key={tx_id + index} onChange={() => handleAccordionOpen(index)}>
                                    <AccordionSummary
                                        sx={{
                                            borderTopLeftRadius: '15px',
                                            borderTopRightRadius: '15px',
                                            backgroundImage: 'linear-gradient(to right, #F7931A , #6444fe)',
                                        }} expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} aria-controls="panel1-content" id="panel1-header">
                                        <div id="accordion-summary">
                                            <div id="accordion-iterms" onClick={() => navTo(tx_id)}>
                                                <FaSearch />
                                            </div>

                                            {/* <div id="accordion-iterms">
                                                {total_mined_commits}
                                                <small>stx committed</small>
                                            </div> */}

                                            <div id="accordion-iterms">
                                                {total_mined_blocks}
                                                <small>blocks</small>
                                            </div>

                                            <div id="accordion-iterms">
                                                {firstBlock}
                                                <small>first block</small>
                                            </div>

                                            <div id="accordion-iterms">
                                                {lastBlock}
                                                <small>last block</small>
                                            </div>
                                        </div>
                                    </AccordionSummary>
                                    <AccordionDetails className="rewards-item">
                                        <ClaimMiningRewardListButton claimList={claimList} setLongClaimList={setLongClaimList} longClaimList={longClaimList} />
                                        {displayMinedData.length > 0 && displayMinedData.map(({ block, claimed, winner, contract_id, pending, total_mined_rewards }) => (
                                            <div id="rewards-summary" key={block}>
                                                <div>{block}</div>
                                                <ClaimMineRewardButton
                                                    claimed={claimed}
                                                    winner={winner}
                                                    contractId={contract_id}
                                                    claimHightBlock={block}
                                                    pending={pending}
                                                    setConfirmTx={setConfirmTx}
                                                    setShowConfirmModal={setShowConfirmModal}
                                                />
                                                <ClaimList claimed={claimed} winner={winner} setLongClaimList={setLongClaimList} longClaimList={longClaimList} block={block} setOpenSnackBar={setOpenSnackBar} setErrorMsg={setErrorMsg} />
                                                {(claimed === null && winner === true) && <AiOutlineLoading3Quarters className="spin" />}
                                                {winner && <div>{total_mined_rewards} <img src="/32-cc.png" /></div>}
                                            </div>
                                        ))}
                                        {minedBlocksLoading && <div>Loading...</div>}
                                        {!minedBlockPageEnded && <Button sx={{ color: 'white', borderColor: '#6444fe' }} disabled={minedBlocksLoading} variant="outlined" onClick={() => handleBlockDataPagination(index)}>Load More</Button>}
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                            {historyLoading && <div>Loading...</div>}
                            {(!historyLoading && !minedBlocksLoading) && <Button sx={{ color: 'white', borderColor: '#6444fe' }} disabled={minePageEnded} variant="outlined" onClick={findMore}>Find More</Button>}
                        </CustomTabPanel>
                    </Box>
                    <div className="elSpacer">
                        <div />
                    </div>
                </div>
            </div>

            <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={() => setOpenSnackBar(false)}>
                <Alert onClose={() => setOpenSnackBar(false)} severity="error" sx={{ width: '100%' }}>
                    {errorMsg}
                </Alert>
            </Snackbar>

            {showConfirmModal && <ConfirmModal show={showConfirmModal} setShow={setShowConfirmModal} close={() => setShowConfirmModal(false)} txId={confirmTx} userSettings={userSettings} />}
            <UserContractDeployModal show={showUserContractDeployModal} setShow={setShowUserContractDeployModal} txId={txId} setTxId={setTxId} setTx_Id={setConfirmTx} userContractStatus={userContractStatus} setUserContractStatus={setUserContractStatus} openConfirmModal={setShowConfirmModal} userSettings={userSettings} />
        </>
    );
};

export default MineRewads;